module.exports = __webpack_public_path__ + "assets/img/mapPeo.ca674851.png";